module.exports = __webpack_public_path__ + "img/a215_reset.60ce76cc.png";